<template lang="pug">
.content-wrapper(v-if='currentUser.rights.staff == true')
  .table-header.d-flex.pb-2.justify-content-between
    h2.m-0 Сотрудники
    button(v-bind:class="['btn', 'btn-info', 'border-0', 'col-2', {'d-none': currentUser.rights.editStaff == false}]" v-on:click='createUser') Добавить сотрудника
  .clients-table
    .d-flex.mb-2.justify-content-between
      select.form-control.col-3(v-model='selectedFilter')
        option(value='' disabled='' selected='') Выберите роль
        option(value='') Все
        option(v-for='role in roles' v-bind:key='role.id' v-bind:value='role.id') {{role.name}}
      input.form-control.col-5(type='text' v-model='searchQuery' placeholder='Search')
    table.table.table-hover
      thead
        tr
          th(v-for='h in columnsHeader' v-bind:key='h.key' v-on:click='sortBy(h.key)' v-bind:class='{ active: sortKey == h.key }')
            | {{ h.title }}
            span(v-bind:class="['arrow', sortOrders[h.key] > 0 ? 'asc' : 'dsc', {'d-none': h.key =='actions'}]")
      tbody
        tr(v-for='(row, index) in filteredUsers' v-bind:key='row.id')
          td(v-for='td in columnsHeader' v-bind:key='td.id')
            span(v-if="td.key === 'actions'" v-bind:class="['td-actions', {'d-none': currentUser.rights.editStaff == false}]")
              a(href='#' v-if="currentUser.rights.canSubLogin != false && row.id != currentUser.id" v-on:click='subAuth(row.id)')
                i.fas.fa-user
              span(v-bind:class="{'d-none': currentUser.rights.editStaff == false}")
                i.fas.fa-pen(v-on:click='editUser(index, row.id)')
                a(href='#')
                  i.fas.fa-envelope
                i(v-bind:class="['fas', 'fa-trash', {'d-none': row.client_id == '0'}]" v-on:click='removeItem(index, row.id)')
            span(v-if="td.key === 'role_id'")
              | {{ getRoleName(row.role_id) }}
            span(v-else) {{ row[td.key] }}
  modal(v-show='isModalVisible' v-on:close='closeModal')
    template(v-slot:header='')
      h2(v-if='!!formData.id') Редактирование
      h2(v-else) Новый сотрудник
    template(v-slot:body='')
      form#usersForm(v-on:submit.prevent='formSubmit')
        .form-group.col-12
          label(for='inputName') Сотрудник
          input#inputName.form-control(type='text' placeholder='Введите данные' v-model='formData.name' required='')
        .form-group.col-12
          label(for='inputEmail') Email
          input#inputEmail.form-control(v-model='formData.email' type='email' placeholder='Введите email' required='')
        .form-row.col-12
          .form-group.col-6
            label(for='inputTel') Телефон
            input#inputTel.form-control(v-model='formData.phone' type='tel' placeholder='Введите телефон')
          .form-group.col-6
            label(for='selectRole') Роль
            select#selectRole.form-control(v-model='formData.role_id')
              option(v-for='role in roles' v-bind:key='role.id' v-bind:value='role.id')
                | {{ role.name }}
        .form-group.d-flex.justify-content-between.col-12.flex-wrap.mb-5
          label.col-12.p-0(v-if='!!formData.id' for='InputPassword') Изменить пароль
          label.col-12(v-else for='InputPassword') Пароль
          input#InputPassword.form-control.col-6(v-model='formData.password' type='text' placeholder='Введите пароль')
          span.btn.btn-info.col-3(v-on:click='getPassword') Генерация пароля
        .d-flex.flex-wrap.col-12(v-if='!!formData.id')
          h4.col-12 Настройки SIP
            span.btn.btn-info(v-on:click='generateSip(formData.id)') Сгенерировать
          input.form-control(type='hidden' v-bind:value='sipData.id')
          input.form-control(type='hidden' v-bind:value='formData.id')
          .form-group.col-6
            label(for='sip_server') sip_server
            input#sip_server.form-control(type='text' v-model='sipData.sip_server')
          .form-group.col-6
            label(for='sip_port') sip_port
            input#sip_port.form-control(type='text' v-model='sipData.sip_port')
          .form-group.col-6
            label(for='sip_user') sip_user
            input#sip_user.form-control(type='text' v-model='sipData.sip_user')
          .form-group.col-6
            label(for='sip_password') sip_password
            input#sip_password.form-control(type='text' v-model='sipData.sip_password')
          .d-flex.col-12
            label(for='internal_client') Внутренний SIP-клиент
            input#internal_client.ml-2.align-self-center(type='checkbox' v-model='sipData.internal_client')
    template(v-slot:footer='')
      .form-group.d-flex.justify-content-between.col-12
        button(v-bind:class="['btn', 'btn-info', 'col-2', {'d-none': currentUser.rights.editStaff == false}]" type='submit' form='usersForm') Сохранить
        button.btn.btn-secondary.col-2(type='submit' v-on:click='closeModal') Отмена
.alert.alert-warning.alert-dismissible.fade.show(v-else role='alert')
  strong Holy guacamole!
  |  You should check your rights.
  button.close(type='button' data-dismiss='alert' aria-label='Close')
    span(aria-hidden='true') &times;
</template>
<script>
export default {
  data: function () {
    var columnsHeader = [
      {title: 'Сотрудник', key: 'name'},
      {title: 'Телефон', key: 'phone'},
      {title: 'Email', key: 'email'},
      {title: 'Дата регистрации', key: 'reg_date'},
      {title: 'Роль', key: 'role_id'},
      {title: 'Действия ', key: 'actions'}
    ]
    var sortOrders = {}
    columnsHeader.forEach(function (key) {
      sortOrders[key.key] = 1
    })
    return {
      isModalVisible: false,
      deleteUserIndex: 0,
      formData: {
        id: 0,
        name: '',
        email: '',
        phone: '',
        reg_date: '',
        password: '',
        client_id: this.client_id,
        role_id: 0,
        roles: this.roles
      },
      sortKey: '',
      sortOrders: sortOrders,
      searchQuery: '',
      selectedFilter: '',
      columnsHeader: columnsHeader,
      users: null,
      roles: null,
      sipData: []
    }
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key
      this.sortOrders[key] *= -1
    },
    getPassword () {
      var password = ''
      var symbols = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      var length = 8
      for (var i = 0; i < length; i++) {
        password += symbols.charAt(Math.floor(Math.random() * symbols.length))
      }
      this.formData.password = password
    },
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
    createUser () {
      this.refreshFormData()
      this.showModal()
    },
    saveUser (response) {
      var user = response.data.user
      if (this.formData.id < 1) {
        this.users.unshift(user)
      } else {
        var index = this.users.map(function (el) { return el.id * 1 }).indexOf(user.id)
        var keys = Object.keys(user)
        for (var ind in keys) {
          var key = keys[ind]
          this.users[index][key] = user[key]
        }
      }
    },
    deleteUser (response) {
      var data = response.data
      if (!data.error) {
        this.users.splice(this.deleteUserIndex, 1)
      } else {
        alert('Ошибка удаления сотрудника ' + data.error_description)
      }
    },
    generateSip (userId) {
      var sipData = {}
      sipData.action = 'generateSipSettings'
      sipData.user_id = userId
      this.axios.post(this.systemSettings.api_host + '/ajax.php', sipData)
        .then(response => {
          this.sipData = response.data.sip_settings
          console.log(this.sipData)
        })
    },
    formSubmit (event) {
      var p = this.formData
      var sipData = this.sipData
      sipData.action = 'saveSipSettings'
      p.action = 'saveUser'
      this.axios.post(this.systemSettings.api_host + '/ajax.php', sipData)
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        .then(this.saveUser)
      this.closeModal()
    },
    refreshFormData () {
      this.formData = {
        id: '',
        name: '',
        email: '',
        phone: '',
        reg_date: '',
        client_id: this.client_id,
        password: '',
        role_id: 0,
        roles: this.roles
      }
    },
    editUser (index, id) {
      this.formData = JSON.parse(JSON.stringify(this.users[index]))
      this.formData.password = ''
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getSipSettings&user_id=' + id)
        .then(response => {
          this.sipData = response.data.sip_settings
          console.log(this.sipData)
        })
      this.showModal()
    },
    removeItem (index, id) {
      var result = confirm('Подтвердите удаление сотрудника')
      if (result) {
        var p = {
          action: 'deleteUser',
          id: id
        }
        this.deleteUserIndex = index
        this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
          .then(this.deleteUser)
      }
    },
    getRoleName (id) {
      if (this.roles === null) {
        return ''
      }
      return this.roles.filter(item => item.id == id)[0].name
    },
    subAuth (id) {
      if (id < 1) {
        return false
      }
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=auth&sub_auth=' + id)
        .then(response => (window.location.href = '/'))
    }
  }, // end of methods
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    filteredUsers: function () {
      var sortKey = this.sortKey
      var filterKey = this.searchQuery
      var users = this.users
      var selectedFilter = this.selectedFilter
      var order = this.sortOrders[sortKey] || 1
      if (filterKey || selectedFilter != '') {
        users = this.users.filter(function (row) {
          return Object.keys(row).some(function (key) {
            if (selectedFilter == row['role_id']) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            }
            return false
          })
        })
      }
      if (sortKey) {
        users = users.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return users
    },
    client_id: function () {
      return this.$store.getters.client_id
    },
    currentUser () {
      return this.$store.getters.user
    }
  },
  mounted () {
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getRolesList&client_id=' + this.client_id)
      .then(response => (this.roles = response.data.roles))
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getUsersList&client_id=' + this.client_id)
      .then(response => (this.users = response.data.users))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users.vue